export default function checkHasTrialPeriod(trialPeriodDays) {
  return trialPeriodDays && trialPeriodDays > 0;
}
